<template>
  <StringFilter
    v-if="
      (fieldDefinition.format === GenericTableSchemaFormat.STRING ||
        fieldDefinition.format === GenericTableSchemaFormat.LANGUAGE_RECORD) &&
      isStringFilter(filterValue)
    "
    v-model="filterValue"
    :description="columnName"
  ></StringFilter>
  <NumberFilter
    v-else-if="
      (fieldDefinition.format === GenericTableSchemaFormat.INTEGER ||
        fieldDefinition.format === GenericTableSchemaFormat.FLOAT ||
        fieldDefinition.format === GenericTableSchemaFormat.DECIMAL) &&
      isNumberFilter(filterValue)
    "
    v-model="filterValue"
    :description="columnName"
  ></NumberFilter>
  <DateFilter
    v-else-if="
      (fieldDefinition.format === GenericTableSchemaFormat.DATE ||
        fieldDefinition.format === GenericTableSchemaFormat.DATE_TIME) &&
      isDateFilter(filterValue)
    "
    v-model="filterValue"
    :format="fieldDefinition.format"
  ></DateFilter>
  <BooleanFilter
    v-else-if="fieldDefinition.format === GenericTableSchemaFormat.BOOLEAN && isBooleanFilter(filterValue)"
    v-model="filterValue"
  ></BooleanFilter>
  <ArrayFilter
    v-else-if="fieldDefinition.format === GenericTableSchemaFormat.ARRAY && isArrayFilter(filterValue)"
    v-model="filterValue"
    :description="columnName"
  ></ArrayFilter>
</template>

<script setup lang="ts">
import { GenericTableSchemaFormat } from "../../enum.genericTableSchemaFormat";
import {
  FilterValueType,
  isArrayFilter,
  isBooleanFilter,
  isDateFilter,
  isNumberFilter,
  isStringFilter,
} from "../../type.genericTableQuery";
import { FieldDefinition } from "../../type.genericTableSchema";
import ArrayFilter from "./ArrayFilter.vue";
import BooleanFilter from "./BooleanFilter.vue";
import DateFilter from "./DateFilter.vue";
import NumberFilter from "./NumberFilter.vue";
import StringFilter from "./StringFilter.vue";

defineProps<{
  columnName: string;
  fieldDefinition: FieldDefinition;
}>();
const filterValue = defineModel<FilterValueType>({ required: true });
</script>
